// extracted by mini-css-extract-plugin
export default {"remove":"LogicDetailsRules_remove__9m4ke"};